import React from 'react';
import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import { required } from '../FormValidation';

const FormSchoolYearPicker = ({ label, name, rules, ...rest }) => {
  const disabledDates = (current) => {
    const currentYear = dayjs().year();
    const currentMonth = dayjs().month();
    const ongoingSchoolYearStart =
      currentMonth > 8 ? currentYear : currentYear - 1;
    return current && current.year() < ongoingSchoolYearStart;
  };

  const formatSchoolYear = (date) => {
    if (!date) return '';
    const year = date.year();
    return `${year}/${year + 1}`;
  };

  // Transformácia hodnoty pre formulár
  const transformValue = (e) => {
    if (!e) return null;

    // Konvertujeme na dayjs objekt ak ešte nie je
    const date = dayjs.isDayjs(e) ? e : dayjs(e);
    return date.isValid() ? date.year() : null;
  };

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      normalize={transformValue}
      getValueProps={(value) => ({
        value: value ? dayjs(`${value}-01-01`) : null,
      })}
    >
      <DatePicker
        picker="year"
        disabledDate={disabledDates}
        style={{ width: '100%' }}
        format={formatSchoolYear}
        {...rest}
      />
    </Form.Item>
  );
};

export default FormSchoolYearPicker;
